import type { SubmissionError } from '@kuow/core';

const PAYMENT_FAILURE_CODES = new Set([4001, 4002]);

export const SUBMISSION_ERROR_FALLBACK_MESSAGE =
  'Sorry, there was a problem processing your request. Please contact us for assistance at membership@kuow.org or call 206-221-2501.';


const normalizeSubmissionErrorCode = (
  code: SubmissionError['code'] | number | null | undefined
): number | null => {
  if (typeof code === 'number') {
    return code;
  }

  if (typeof code === 'string') {
    const parsed = Number(code);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const isPaymentFailureCode = (
  code: SubmissionError['code'] | number | null | undefined
): boolean => {
  const normalized = normalizeSubmissionErrorCode(code);
  return normalized !== null && PAYMENT_FAILURE_CODES.has(normalized);
};

export const isPaymentFailureError = (errors: SubmissionError[]): boolean => {
  return errors.some((error) => isPaymentFailureCode(error.code));
};

export const getPrimarySubmissionError = (
  errors: SubmissionError[],
  fallbackMessage: string
): SubmissionError => {
  if (errors.length > 0) {
    return errors[0];
  }

  return { message: fallbackMessage };
};

export const getSubmissionErrorMessage = (error: SubmissionError | null): string | null => {
  return error ? error.message : null;
};